/**
 * 仿拍镜头结构轨(BPWB-1,2026-09-03)—— 蓝图工作卡的结构插槽之一。
 *
 * 块宽 ∝ 该卡成片秒数(flex-grow),超 12s 长镜标「自动切 N 拍」;数据派生在
 * model/shotRail.ts(与 ai scaffold 同源镜像,那边头注有账)。标签行由页面自己写
 * (「共 N 镜 · 成片约 Xs · 跟原片走」的措辞归目的地),这里只画块。
 */
import { railTimeLabel, type ShotRailPlan } from "../model/shotRail";

export function BlueprintShotRail({ plan }: { plan: ShotRailPlan }) {
  if (plan.items.length === 0) return null;
  return (
    <div data-testid="blueprint-shot-rail" className="flex gap-1">
      {plan.items.map((it, i) => {
        const time = railTimeLabel(it);
        return (
          <div
            key={i}
            className="relative min-w-0 overflow-hidden rounded-md border border-border/60 bg-card px-1.5 py-1"
            style={{ flexGrow: Math.max(it.durSec, 1), flexBasis: 0 }}
          >
            <div className="flex items-center gap-1">
              <span className="font-mono text-[10px] font-semibold text-primary/80">
                {/* 无时间轴的卡:诚实标出来 —— 那一镜不挂原片段,画面回文字想象 */}
                {time || "无时间轴"}
              </span>
              {it.takeCount > 1 && (
                <span className="whitespace-nowrap rounded border border-warning/40 px-1 text-[9.5px] text-warning-foreground">
                  自动切 {it.takeCount} 拍
                </span>
              )}
            </div>
            {it.desc && (
              <div className="mt-0.5 line-clamp-2 text-2xs leading-snug text-muted-foreground">
                {it.desc}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
